export const WORKER_FUNC_MAX_COUNT = 5;

// 函数
export enum WORKER_FUNC {
    OPEN_MODAL = 'openModal',
    CLOSE_MODAL = 'closeModal',
    CALL_FUNCTION = 'callFunction',
    OPEN_URL = 'openUrl'
}

// 消息类型
export enum WORKER_MESSAGE_TYPE {
    CALL = 'call',
    CALL_RESULT = 'callResult',
    UI_MESSAGE = 'uiMessage',
    ERROR = 'error',
    OVER = 'over',
    RUN = 'run'
}

// 错误消息
export enum WORKER_ERROR_MESSAGE {
    CALL_FUNC_OVER = 'CALL FUNCTION OVER MAX COUNT'
}
